// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8aj4M","comment":"styles_comment__1gGOz"};